export default "__VITE_ASSET__CIKVNtj5__"